export default __webpack_public_path__ + "static/media/icon__17.8fef4811.svg";